module.exports = __webpack_public_path__ + "img/s6.85dfa224.jpg";